import React, { Component } from "react";

export default class BusinessSummarySheet extends Component {
  constructor(props) {
    super(props);
    this.refs = {
      businessSummaryForm: React.createRef(),
    };
    this.state = {};
    this.businessSummaryFields = [
      {
        name: "turnoverSummary",
        label: "Business Turnover Summary",
        type: "file",
        editaccess: "false",
      },
    ];
  }
  render() {
    let { businessSummaryFields } = this;
    return (
      <>
        <AppForm
          className="row mb-2"
          ref="businessSummaryForm"
          id="businessSummaryForm"
          onSubmit={() => this.saveBusinessSummarySheetForm()}
        >
          {businessSummaryFields.map((field, i) => (
            <div className="col-sm-6 col-md-3" key={i}>
              <AppInput {...field}></AppInput>
            </div>
          ))}
        </AppForm>
      </>
    );
  }
}